export default {
  BASE_URL: process.env.REACT_APP_BASE_URL || "http://localhost:3000/",
  PATIENT_URL: process.env.REACT_APP_PATIENT_URL,
  APPLICATION_ID: process.env.REACT_APPLICATION_ID || "h5tasAJfd1zTKQDUR8tauJ62jozjcEbSjEhMfvqv",
  REST_API_KEY: process.env.REACT_REST_API_KEY || "OUGtoLj0CFppHV0bc7YxNffROKAnYM2ThzVhOKjT",
  REACT_APP_GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || "",
  REACT_APP_GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
};
